<template>
  <div
    :class="[
      'rounded-lg border border-[#A5B4FC] bg-white shadow-[0px_4px_6px_-2px_rgba(0,0,0,0.05)]',
      compact ? 'p-2' : 'p-4'
    ]"
    data-testid="pin-ready-card"
  >
    <div :class="['flex items-start', compact ? 'gap-1.5' : 'gap-3']">
      <SparkleIcon
        :class="['mt-0.5 shrink-0 text-[#6366F1]', compact ? 'h-3.5 w-3.5' : 'h-5 w-5']"
      />
      <div :class="['flex flex-col', compact ? 'gap-0.5' : 'gap-1']">
        <h4 class="m-0 text-xs font-bold uppercase tracking-wide text-[#6366F1]">
          WE'VE GOT YOUR BACK — OUR ARTISTS WILL UPDATE THE DESIGN BASED ON YOUR INSTRUCTIONS BELOW
        </h4>
        <span class="whitespace-pre-wrap text-sm text-gray-700">{{ instruction }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import SparkleIcon from "assets/icons/sparkle.svg?vue";

defineOptions({ name: "PinReadyCard" });

defineProps({
  instruction: { type: String, required: true },
  compact: { type: Boolean, default: false }
});
</script>
